__turbopack_context__.v({
  "divider": "Store-module-scss-module__BdKkUq__divider",
  "heading": "Store-module-scss-module__BdKkUq__heading",
  "headingContainer": "Store-module-scss-module__BdKkUq__headingContainer",
  "left": "Store-module-scss-module__BdKkUq__left",
  "myStore": "Store-module-scss-module__BdKkUq__myStore",
  "right": "Store-module-scss-module__BdKkUq__right",
  "row": "Store-module-scss-module__BdKkUq__row",
  "storeAlertText": "Store-module-scss-module__BdKkUq__storeAlertText",
  "storesListContainer": "Store-module-scss-module__BdKkUq__storesListContainer",
  "storesListItem": "Store-module-scss-module__BdKkUq__storesListItem",
  "topHeadingContainer": "Store-module-scss-module__BdKkUq__topHeadingContainer" + " " + "Store-module-scss-module__BdKkUq__headingContainer",
  "warningMessage": "Store-module-scss-module__BdKkUq__warningMessage",
});
